import {Observable} from "rxjs/Rx";
import {INotificationsCommonWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {CerbaCookieService, CookieConstantes} from "@digicerba/common";

@Injectable()
export class NotificationNumberResolver implements Resolve<any> {

  constructor(private notificationsWebService: INotificationsCommonWebServiceClient, private cookieService: CerbaCookieService) {
  }

  resolve() {
    const authCookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);
    if (authCookieValue) {
      return this.notificationsWebService.countMessageNotifications().catch(response => {
        return Observable.of(0);
      });
    } else {
      console.log("no notif");
      return Observable.of(0);
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/notification.resolver.ts